import io from "socket.io-client";
import {
    UPDATE_CLIENT_STATUS,
    UPDATE_DRIVER_STATUS,
    UPDATE_NEW_ORDER

} from "./type";

let MaktabtySocket = null;

export function init() {
    return (dispatch, getState) => {

        MaktabtySocket = io(`https://www.maktabtiy.com:3000/utils`, {
            query: {
                id: JSON.parse(localStorage.getItem("id")),
                type: JSON.parse(localStorage.getItem("maktaptiType"))
            }
        }
        );
        MaktabtySocket.on('connect', () => { console.log('dataaaaaa socket', MaktabtySocket, localStorage.getItem("id"), JSON.parse(localStorage.getItem("maktaptiType"))) }
        );


        MaktabtySocket.on('ClientStatus', data => {
            console.log("dataaaaaa socketClient:", data)
            dispatch({ type: UPDATE_CLIENT_STATUS, payload: data });

        })
        MaktabtySocket.on('DriverStatus', data => {
            console.log("dataaaaaa socketDriver:", data)
            dispatch({ type: UPDATE_DRIVER_STATUS, payload: data });

        })
        MaktabtySocket.on('NewOrder', data => {
            console.log("dataaaaaa socketneworder:", data)
            dispatch({ type: UPDATE_NEW_ORDER, payload: data });

        })
    }
}